import ProjectsPage from '../../components/ProjectsPage'

const Lab = () => <ProjectsPage mode='lab' />

export default Lab
